export default {
  props: {
    title: {
      type: Object,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    grid: {
      type: String,
      required: false,
      default: '2',
    },
    image: {
      type: Object,
      required: false,
    },
    imageBrand: {
      type: Object,
      required: false,
    },
  },
}
